<!--
 * @Descripttion: 全部商品页面组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 20:56:01
--> 

<template>
  <div class="goods" id="goods" name="goods">
    <!-- Page Header -->
    <div class="page-header">
      <div class="page-header-bg"></div>
      <div class="page-header-content">
        <h1>Our Collection</h1>
        <p>Discover elegant ethnic wear for every occasion</p>
      </div>
    </div>

    <!-- Main Layout with Sidebar -->
    <div class="goods-layout">
      <!-- Sidebar Filters -->
      <aside class="sidebar">
        <div class="sidebar-header">
          <div class="sidebar-icon">🔍</div>
          <h3>Filters</h3>
          <button class="clear-filters" @click="clearFilters">Clear All</button>
        </div>

        <!-- Price Filter -->
        <div class="filter-section">
          <h4 class="filter-title">Price Range</h4>
          <div class="filter-options">
            <label class="filter-option">
              <input type="radio" value="0-500" v-model="priceRange" @change="applyFilters" />
              <span class="checkmark"></span>
              Under ₹500
            </label>
            <label class="filter-option">
              <input type="radio" value="500-1000" v-model="priceRange" @change="applyFilters" />
              <span class="checkmark"></span>
              ₹500 - ₹1000
            </label>
            <label class="filter-option">
              <input type="radio" value="1000-2000" v-model="priceRange" @change="applyFilters" />
              <span class="checkmark"></span>
              ₹1000 - ₹2000
            </label>
            <label class="filter-option">
              <input type="radio" value="2000-99999" v-model="priceRange" @change="applyFilters" />
              <span class="checkmark"></span>
              Above ₹2000
            </label>
          </div>
        </div>

        <!-- Sort -->
        <div class="filter-section">
          <h4 class="filter-title">Sort By</h4>
          <div class="filter-options">
            <label class="filter-option">
              <input type="radio" value="newest" v-model="sortBy" @change="applyFilters" />
              <span class="checkmark"></span>
              Newest First
            </label>
            <label class="filter-option">
              <input type="radio" value="price-low" v-model="sortBy" @change="applyFilters" />
              <span class="checkmark"></span>
              Price: Low to High
            </label>
            <label class="filter-option">
              <input type="radio" value="price-high" v-model="sortBy" @change="applyFilters" />
              <span class="checkmark"></span>
              Price: High to Low
            </label>
          </div>
        </div>

        <!-- Promo Card -->
        <div class="sidebar-promo">
          <div class="promo-badge">NEW</div>
          <h4>Festive Collection</h4>
          <p>Up to 40% Off on designer sarees & lehengas</p>
          <router-link to="/goods" class="promo-link">Shop Now</router-link>
        </div>
      </aside>

      <!-- Products Area -->
      <div class="products-area">
        <!-- Category Tabs -->
        <div class="category-tabs">
          <button
            v-for="item in categoryList"
            :key="item.category_id"
            class="category-tab"
            :class="{active: activeName === ''+item.category_id}"
            @click="selectCategory(item.category_id)"
          >
            {{ item.category_name }}
          </button>
        </div>

        <!-- Results Info -->
        <div class="results-info">
          <span>{{ total }} products found</span>
        </div>

        <!-- Products Grid -->
        <div class="list">
          <MyList :list="product" v-if="product.length>0"></MyList>
          <div v-else class="none-product">
            <div class="empty-state">
              <div class="empty-icon">👗</div>
              <h3>No products found</h3>
              <p>Try adjusting your filters or browse our categories</p>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div class="pagination" v-if="product.length>0">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :layout="paginationLayout"
            :small="isMobile"
            :total="total"
            :next-text="next"
            :prev-text="prev"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productAPI from '@/api/products'
import * as categoryAPI from '@/api/categories'
import axios from 'axios'

export default {
  data() {
    return {
      categoryList: '', //分类列表
      categoryID: [], // 分类id
      product: [], // 商品列表
      productList: [],
      total: 0, // 商品总量
      pageSize: 16, // 每页显示的商品数量
      currentPage: 1, //当前页码
      activeName: '-1', // 分类列表当前选中的id
      search: '', // 搜索条件
      start: 0,
      limit: 16,
      initializing: false,
      syncingRoute: false,
      isActive: false,
      isMobile: false,
      tabsWrap: null,
      // Filter states
      selectedCategory: 0,
      priceRange: '0-99999',
      sortBy: 'newest'
    }
  },
  created() {
    // 获取分类列表
    this.getCategory()
    // 初始化移动端标识
    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 900
    }
  },
  activated() {
    this.isActive = true
    if (typeof window !== 'undefined') {
      this.handleResize = () => {
        this.isMobile = window.innerWidth <= 900
      }
      window.addEventListener('resize', this.handleResize)
    }
    this.$nextTick(() => {
      this.bindTabsWrap()
    })
    this.initializing = true
    this.activeName = '-1'
    this.total = 0
    this.currentPage = 1
    if (Object.keys(this.$route.query).length === 0) {
      this.categoryID = []
      this.activeName = '0'
      this.initializing = false
      this.start = 0
      this.getData()
      return
    }
    if (this.$route.query.categoryID !== undefined) {
      const raw = this.$route.query.categoryID
      if (Array.isArray(raw)) {
        this.categoryID = raw.map(v => Number(v))
      } else if (typeof raw === 'string') {
        this.categoryID = raw.split(',').map(v => Number(v))
      } else {
        this.categoryID = [Number(raw)]
      }
      if (this.categoryID.length === 1) this.activeName = '' + this.categoryID[0]
      this.initializing = false
      this.start = 0
      this.getData()
      return
    }
    if (this.$route.query.search !== undefined) {
      this.search = this.$route.query.search
      this.initializing = false
      this.getProductBySearch()
    }
  },
  deactivated() {
    this.isActive = false
    if (typeof window !== 'undefined' && this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
    this.unbindWheel()
  },
  computed: {
    paginationLayout() {
      return this.isMobile ? 'prev, pager, next' : 'total, prev, pager, next, jumper'
    }
  },
  watch: {
    // 监听点击了哪个分类标签，通过修改分类id，响应相应的商品
    activeName: function(val) {
      if (this.initializing || this.syncingRoute || !this.isActive) return
      // 若与当前路由一致则不更新，避免多余导航
      const nextQuery =
        val == 0 ? {} : { categoryID: '' + Number(val) }
      const currentQuery = this.$route.query || {}
      const same =
        ((val == 0) && !('categoryID' in currentQuery)) ||
        (val != 0 && currentQuery.categoryID == String(val))
      if (same) {
        // 直接触发数据加载
        this.categoryID = val == 0 ? [] : [Number(val)]
        this.total = 0
        this.currentPage = 1
        this.start = 0
        this.getData()
        return
      }
      if (val == 0) {
        this.categoryID = []
      }
      if (val > 0) {
        this.categoryID = [Number(val)]
      }
      // 初始化商品总量和当前页码
      this.total = 0
      this.currentPage = 1
      this.start = 0
      // 更新地址栏链接，方便刷新页面可以回到原来的页面
      this.$router.replace({
        path: '/goods',
        // 统一使用逗号拼接，避免解析为字符串时只取第一位
        query: { categoryID: this.categoryID.join(',') }
      })
    },
    // 监听搜索条件，响应相应的商品
    search: function(val) {
      if (val != '' && this.isActive) {
        this.getProductBySearch(val)
      }
    },
    // 监听分类id，响应相应的商品
    categoryID: function() {
      if (this.initializing || !this.isActive) return
      this.start = 0
      this.getData()
      this.search = ''
    },
    // 监听路由变化，更新路由传递了搜索条件/分类
    $route: function(val) {
      if (val.path == '/goods') {
        if (val.query.search != undefined) {
          this.activeName = '-1'
          this.currentPage = 1
          this.total = 0
          this.search = val.query.search
          return
        }
        if (val.query.categoryID != undefined) {
          this.syncingRoute = true
          const raw = val.query.categoryID
          let nextIds = []
          if (Array.isArray(raw)) {
            nextIds = raw.map(v => Number(v))
          } else if (typeof raw === 'string') {
            nextIds = raw.split(',').map(v => Number(v))
          } else {
            nextIds = [Number(raw)]
          }
          const same =
            Array.isArray(this.categoryID) &&
            this.categoryID.length === nextIds.length &&
            this.categoryID.every((v, i) => v === nextIds[i])
          if (!same) {
            this.categoryID = nextIds
          }
          if (nextIds.length === 1 && this.activeName !== '' + nextIds[0]) {
            this.activeName = '' + nextIds[0]
          }
          this.$nextTick(() => {
            this.syncingRoute = false
          })
          // 此处不调用 getData，避免 categoryID watch 重复触发
        }
      }
    }
  },
  methods: {
    bindTabsWrap() {
      if (!this.$refs.categoryTabs) return
      const scrollEl = this.$refs.categoryTabs.$el.querySelector('.el-tabs__nav-scroll')
      this.tabsWrap = scrollEl
      this.bindWheel()
    },
    bindWheel() {
      if (!this.tabsWrap || this._wheelBound) return
      this._wheelHandler = e => {
        // 将垂直滚动转为水平滚动
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          this.tabsWrap.scrollLeft += e.deltaY
          e.preventDefault()
        }
      }
      this.tabsWrap.addEventListener('wheel', this._wheelHandler, { passive: false })
      this._wheelBound = true
    },
    unbindWheel() {
      if (this.tabsWrap && this._wheelBound && this._wheelHandler) {
        this.tabsWrap.removeEventListener('wheel', this._wheelHandler)
        this._wheelBound = false
      }
    },
    scrollTabs(direction) {
      if (!this.tabsWrap) return
      const step = 160
      if (direction === 'left') {
        this.tabsWrap.scrollLeft -= step
      } else {
        this.tabsWrap.scrollLeft += step
      }
    },
    selectCategory(id) {
      this.activeName = '' + id
      this.categoryID = id === 0 ? [] : [id]
      this.start = 0
      this.getData()
    },
    clearFilters() {
      this.selectedCategory = 0
      this.priceRange = '0-99999'
      this.sortBy = 'newest'
      this.activeName = '-1'
      this.categoryID = []
      this.start = 0
      this.getData()
    },
    applyFilters() {
      // For now, just refresh the data - actual filtering happens on backend
      this.start = 0
      this.getData()
    },
    // 返回顶部
    backtop() {
      const timer = setInterval(function() {
        const top =
          document.documentElement.scrollTop || document.body.scrollTop
        const speed = Math.floor(-top / 5)
        document.documentElement.scrollTop = document.body.scrollTop =
          top + speed

        if (top === 0) {
          clearInterval(timer)
        }
      }, 20)
    },
    handleCurrentChange(val) {
      this.start = this.limit * (val - 1) // val 页面
      this.getData()
    },
    // 向后端请求分类列表数据
    getCategory() {
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const val = {
              category_id: 0,
              category_name: 'All'
            }
            const cate = res.data
            cate.unshift(val)
            this.categoryList = cate
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
    },
    // 向后端请求全部商品或分类商品数据
    getData() {
      if (!this.isActive) return
      // Parse price range
      const [minPrice, maxPrice] = this.priceRange.split('-').map(v => Number(v))
      // 如果分类列表为空则请求全部商品数据，否则请求分类商品数据
      if (this.categoryID.length === 0) {
        productAPI
          .listProducts(0, this.start, this.limit, minPrice, maxPrice)
          .then(res => {
            if (res.status === 200) {
              this.product = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
              this.total = res.data.total || 0
            } else {
              this.notifyError('Failed to obtain product', res.msg)
            }
          })
          .catch(err => {
            this.notifyError('Failed to obtain product', err)
          })
      } else {
        let id = this.categoryID[0]
        productAPI
          .listProducts(id, this.start, this.limit, minPrice, maxPrice)
          .then(res => {
            if (res.status === 200) {
              this.product = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
              this.total = res.data.total || 0
            } else {
              this.notifyError('Failed to obtain product', res.msg)
            }
          })
          .catch(err => {
            this.notifyError('Failed to obtain product', err)
          })
      }
    },
    // 通过搜索条件向后端请求商品数据
    getProductBySearch() {
      var form = {
        search: this.search
      }
      productAPI
        .searchProducts(form)
        .then(res => {
          if (res.status === 200) {
            this.product = this.shuffle(Array.isArray(res.data) ? res.data : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  }
}
</script>

<style scoped>
.goods {
  background-color: #FAF6EF;
  min-height: 100vh;
}

/* Page Header */
.page-header {
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.page-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #2E4A7B 0%, #1A3A6E 50%, #E5B49A 100%);
}
.page-header-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.06'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.page-header-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 20px;
}
.page-header-content h1 {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.page-header-content p {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
}

/* Main Layout */
.goods-layout {
  max-width: 1280px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  display: flex;
  gap: 32px;
}

/* Sidebar */
.sidebar {
  flex: 0 0 280px;
  background: #ffffff;
  border-radius: 20px;
  padding: 28px;
  height: fit-content;
  box-shadow: 0 4px 20px rgba(46, 74, 123, 0.08);
  border: 1px solid rgba(46, 74, 123, 0.08);
}
.sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(46, 74, 123, 0.1);
}
.sidebar-icon {
  font-size: 20px;
}
.sidebar-header h3 {
  flex: 1;
  font-size: 18px;
  font-weight: 700;
  color: #2D2D2D;
}
.clear-filters {
  background: none;
  border: none;
  color: #2E4A7B;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 20px;
  transition: all 0.2s ease;
}
.clear-filters:hover {
  background: rgba(46, 74, 123, 0.08);
}

.filter-section {
  margin-bottom: 28px;
}
.filter-title {
  font-size: 13px;
  font-weight: 700;
  color: #2E4A7B;
  margin-bottom: 14px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}
.filter-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.filter-option {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 14px;
  color: #6B6B6B;
  padding: 8px 0;
  transition: color 0.2s ease;
}
.filter-option:hover {
  color: #2E4A7B;
}
.filter-option input {
  display: none;
}
.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(46, 74, 123, 0.15);
  border-radius: 50%;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.filter-option input:checked + .checkmark {
  border-color: #2E4A7B;
  background: #2E4A7B;
}
.filter-option input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 50%;
}

/* Sidebar Promo */
.sidebar-promo {
  background: linear-gradient(135deg, #2E4A7B 0%, #E5B49A 100%);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  color: #ffffff;
  margin-top: 8px;
}
.promo-badge {
  display: inline-block;
  background: rgba(255,255,255,0.25);
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 12px;
}
.sidebar-promo h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}
.sidebar-promo p {
  font-size: 12px;
  opacity: 0.95;
  margin-bottom: 16px;
  line-height: 1.5;
}
.promo-link {
  display: inline-block;
  background: #ffffff;
  color: #2E4A7B;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.25s ease;
}
.promo-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

/* Products Area */
.products-area {
  flex: 1;
  min-width: 0;
}

/* Category Tabs */
.category-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
  background: #ffffff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(46, 74, 123, 0.06);
  border: 1px solid rgba(46, 74, 123, 0.08);
}
.category-tab {
  padding: 10px 20px;
  background: transparent;
  border: 1.5px solid rgba(46, 74, 123, 0.15);
  border-radius: 25px;
  font-size: 13px;
  font-weight: 600;
  color: #6B6B6B;
  cursor: pointer;
  transition: all 0.25s ease;
}
.category-tab:hover {
  border-color: #2E4A7B;
  color: #2E4A7B;
}
.category-tab.active {
  background: #2E4A7B;
  border-color: #2E4A7B;
  color: #ffffff;
}

/* Results Info */
.results-info {
  margin-bottom: 20px;
  font-size: 14px;
  color: #9B9B9B;
  padding-left: 4px;
}

/* Products Grid */
.list {
  min-height: 600px;
}
.none-product {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
.empty-state {
  text-align: center;
  padding: 48px 24px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(46, 74, 123, 0.06);
}
.empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
}
.empty-state h3 {
  font-size: 20px;
  color: #2D2D2D;
  margin-bottom: 10px;
}
.empty-state p {
  font-size: 14px;
  color: #9B9B9B;
}

/* Pagination */
.pagination {
  margin-top: 40px;
  text-align: center;
}

/* Element UI Pagination Override */
.pagination /deep/ .el-pagination.is-background .el-pager li {
  border-radius: 50%;
}
.pagination /deep/ .el-pagination.is-background .el-pager li:not(.disabled).is-active {
  background-color: #2E4A7B;
}
.pagination /deep/ .el-pagination.is-background .btn-next,
.pagination /deep/ .el-pagination.is-background .btn-prev {
  border-radius: 50%;
}

/* Responsive */
@media (max-width: 1024px) {
  .goods-layout {
    flex-direction: column;
  }
  .sidebar {
    flex: none;
    width: 100%;
  }
}
@media (max-width: 900px) {
  .page-header {
    height: 200px;
  }
  .page-header-content h1 {
    font-size: 28px;
  }
  .page-header-content p {
    font-size: 14px;
  }
  .goods-layout {
    padding: 20px 12px 60px;
  }
  .category-tabs {
    gap: 8px;
    padding: 12px;
  }
  .category-tab {
    padding: 8px 16px;
    font-size: 12px;
  }
  .pagination {
    margin-top: 30px;
  }
  .sidebar {
    padding: 20px;
    border-radius: 16px;
  }
}
</style>
